export default "__VITE_ASSET__CBAY8y$7__"